import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from 'src/store/hooks'
import { hydrateBundle } from 'src/store/joinevent'

const storageKey = 'joinevent:bundle'

const getBundleFromLocalStorage = () => {
    try {
        const persistedState = localStorage.getItem(storageKey)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        if (persistedState) return JSON.parse(persistedState)
    } catch (e) {
        console.log(e)
    }
}

export default function usePersistBundle() {
    const dispatch = useDispatch()
    const bundleState = useAppSelector((state) => state.joinevent.cart.bundle)
    const serverBundle = useAppSelector((state) => state.joinevent.cart.serverBundle)
    const isServerBundleHasChallengeAthleteId = serverBundle?.challenges.some(
        (i) => i.challengeAthleteId !== null
    )
    // const isClientSameAsServerBundle = bundleState?.paymentId === serverBundle?.paymentId
    // const isServerBundleEmpty = serverBundle?.challenges?.length === 0 ?? true

    // console.log(
    //     'isClientSameAsServerBundle',
    //     isClientSameAsServerBundle,
    //     bundleState?.paymentId,
    //     serverBundle?.paymentId
    // )

    // console.log(
    //     'isServerBundleHasChallengeAthleteId',
    //     isServerBundleHasChallengeAthleteId
    // )

    // console.log('isServerBundleEmpty', isServerBundleEmpty, serverBundle)

    useEffect(() => {
        const bundle = getBundleFromLocalStorage()
        if (bundle) dispatch(hydrateBundle(bundle))
    }, [])

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(bundleState))
    }, [bundleState])

    return {
        bundleState,
        serverBundle,
        isServerBundleHasChallengeAthleteId
    }
}
